module.exports = __webpack_public_path__ + "static/img/identity-level-encryption.37ce0cf7.png";